export const BASE_SHARDS_URL = '/shards/employer/statistics';

enum PageUrl {
    LaborMarket = 'https://stats.hh.ru',
    LaborMarketBY = 'https://stats.rabota.by',
    LaborMarketKZ = 'https://stats.hh.kz',
    Index = '/employer/statistics/index',
    HiringCost = '/employer/statistics/hiringCost',
    VacanciesEfficiency = '/employer/statistics/vacanciesEfficiency',
    Vacancies = '/employer/statistics/vacancies',
    Managers = '/employer/statistics/managers',
    VacanciesParameters = '/employer/statistics/vacanciesParameters',
    PolitenessIndex = '/employer/statistics/politenessIndex',
    PolitenessIndexByManagers = '/employer/statistics/politenessIndexByManagers',
    ApplicantsActivity = '/employer/statistics/applicantsActivity',
    CompetitorAnalysis = '/employer/statistics/competitor_analysis',
    CompetitorAnalysisReport = '/employer/statistics/competitor_analysis/report',
    CompetitorAnalysisForVacancy = '/employer/statistics/competitor_analysis/vacancy/:id',
    BrandedVacancies = '/employer/statistics/brandedVacancies',
    BrandedPages = '/employer/statistics/brandedPages',
    ContactsEfficiency = '/employer/statistics/contactsEfficiency',
    PublicationsEfficiency = '/employer/statistics/publicationsEfficiency',
    CallTracking = '/employer/statistics/callTracking',
    VacancyConversion = '/employer/statistics/vacancy_conversion',
    VacancyEdit = '/employer/vacancy/edit/:vacancyId',
}

export enum ShardUrl {
    VacanciesEfficiencyProductivity = '/shards/employer/statistics/reports/vacancies_efficiency/productivity',
    VacanciesEfficiencyEfficiency = '/shards/employer/statistics/reports/vacancies_efficiency/efficiency',
    VacanciesEfficiencySpending = '/shards/employer/statistics/reports/vacancies_efficiency/spending',
    VacanciesEfficiencyPolitenessIndex = '/shards/employer/statistics/reports/vacancies_efficiency/politenessIndex',
    VacanciesEfficiencySpendingByArea = '/shards/employer/statistics/reports/vacancies_efficiency/spending_by_area',
    VacanciesEfficiencyEfficiencyByArea = '/shards/employer/statistics/reports/vacancies_efficiency/efficiency_by_area',
    VacanciesEfficiencyAreasWithLowSalary = '/shards/employer/statistics/reports/vacancies_efficiency/areas_with_low_salary',
    VacanciesEfficiencyDynamics = '/shards/employer/statistics/reports/vacancies_efficiency/dynamics',
    VacanciesEfficiencyDynamicsAdditional = '/shards/employer/statistics/reports/vacancies_efficiency/dynamics_additional',

    ContactsEfficiencyProductivity = '/shards/employer/statistics/reports/contacts_efficiency/productivity',
    ContactsEfficiencyEfficiency = '/shards/employer/statistics/reports/contacts_efficiency/efficiency',
    ContactsEfficiencySpending = '/shards/employer/statistics/reports/contacts_efficiency/spending',
    ContactsEfficiencyPackages = '/shards/employer/statistics/reports/contacts_efficiency/packages',
    ContactsEfficiencySpendingManagerTop = '/shards/employer/statistics/reports/contacts_efficiency/spending_manager_top',
    ContactsEfficiencyDynamics = '/shards/employer/statistics/reports/contacts_efficiency/dynamics',

    PublicationsEfficiencyPackages = '/shards/employer/statistics/reports/publications_efficiency/packages',
    PublicationsEfficiencySpendingManagersTop = '/shards/employer/statistics/reports/publications_efficiency/spending_managers_top',
    PublicationsEfficiencyVacanciesTop = '/shards/employer/statistics/reports/publications_efficiency/vacancies_top',

    VacancyConversion = '/shards/employer/statistics/reports/vacancy_conversion',
    VacanciesParameters = '/shards/employer/statistics/reports/vacanciesParameters',
    CallTracking = '/shards/employer/statistics/reports/callTracking',
    Vacancies = '/shards/employer/statistics/reports/vacancies',
    HiringCost = '/shards/employer/statistics/reports/hiringCost',
    VacanciesEfficiency = '/shards/employer/statistics/reports/vacanciesEfficiency',
    Managers = '/shards/employer/statistics/reports/managers',
    PolitenessIndex = '/shards/employer/statistics/reports/politenessIndex',
    PolitenessIndexByManagers = '/shards/employer/statistics/reports/politenessIndexByManagers',
    ApplicantsActivity = '/shards/employer/statistics/reports/applicantsActivity',
    BrandedVacancies = '/shards/employer/statistics/reports/brandedVacancies',
    ContactsEfficiency = '/shards/employer/statistics/reports/contactsEfficiency',
    PublicationsEfficiency = '/shards/employer/statistics/reports/publicationsEfficiency',

    ManagersList = '/shards/employer/statistics/managers_list',
    AreaTree = '/shards/employer/statistics/area_tree',
    VacancyBrandedTemplates = '/shards/employer/statistics/vacancy_branded_templates',
    ProfRoleTree = '/shards/employer/statistics/prof_role_tree',
    VacancyActiveForPeriodSuggest = '/shards/employer/statistics/vacancy_active_for_period_suggest',

    GetStandardPlusData = '/shards/employer/statistics/standard_plus_vacancy_upgrade',
    CreateCart = '/shards/employer/statistics/create_cart',
    UpgradeVacancy = '/shards/employer/statistics/upgrade_vacancy',
}

export default PageUrl;
